import type { PathsWithMethod } from 'openapi-typescript-helpers'
import { BackendHTTPError } from './BackendHTTPError'
import { OpenApiFetchResponse } from './openApiTypes'

// Unwraps the response from the openapi-fetch client. This is to help reduce boilerplate while
// ensuring url-based type checks are still performed.

export async function unwrapBackendResponse<
  Paths extends {},
  HttpVerb extends 'get' | 'post' | 'put' | 'delete',
  P extends PathsWithMethod<Paths, HttpVerb>,
>(
  promise: Promise<OpenApiFetchResponse<Paths, HttpVerb, P>>,
): Promise<NonNullable<OpenApiFetchResponse<Paths, HttpVerb, P>['data']>> {
  const response = await promise
  // This unwraps the response from the openapi-fetch client.
  if (response.error) {
    console.log('error', response.error)
    throw new BackendHTTPError(
      (response.error as any).detail,
      response.response.status,
      response.response.statusText,
    )
  }

  if (response.data == undefined) {
    if (response.error == undefined) {
      throw new BackendHTTPError('Unknown error', 500, 'Internal Server Error')
    }

    let responseError: string | null = null
    // Based on testing, Django returns a string in the "error" field
    // when an Exception is raised in Python on the backend.
    //
    // When a JSONResponse is returned, the contents of the response will be returned in
    // the "error" field.
    // On the back-end, use get_error_json_response to return JSONResponses which
    // are compatible with the BackendClient.
    if (typeof response.error === 'string') {
      responseError = response.error
    } else if (
      typeof response.error === 'object' &&
      'error' in response.error &&
      typeof response.error.error === 'string'
    ) {
      responseError = response.error.error
    }

    throw new BackendHTTPError(
      responseError || 'Unknown error',
      response.response.status,
      response.response.statusText,
    )
  }
  return response.data
}
